import httpService from '@/services/httpService'

export const types = {
  SET_BACKGROUND_TASKS: 'backgroundTasks/SET_BACKGROUND_TASKS'
}

const state = {
  backgroundTasks: []
}

const mutations = {
  [types.SET_BACKGROUND_TASKS]: function (state, backgroundTasks) {
    state.backgroundTasks = backgroundTasks
  }
}

const actions = {
  getBackgroundTasksData: async function ({ commit }) {
    const response = await httpService.get('/background-tasks')
    if (!response || !response.data) {
      return []
    }
    commit(types.SET_BACKGROUND_TASKS, response.data.data)
    return response.data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
